module.exports = __webpack_public_path__ + "img/horizontal_4_6_8003.7e1e5a0e.png";